
import SampleItem from './sample-item.vue'
import {Uploader} from 'mixins'

export default {
  components: {SampleItem},
  mixins: [Uploader],
  emits: ['uploaded', 'removed'],
  data(){
    return {
      prev_text: '',
      inline_text: '',
      edit_id: undefined
    }
  },
  computed:{
    placeholder(){
      return this.files.length < this.fileRows ? undefined : `Cannot have more than ${this.maxUploads} example posts`
    },
    limit(){
      return this.maxUploads ? this.files.length < this.maxUploads : true
    },
    diff(){
      return this.prev_text !== this.inline_text
    },
    can_type() {
      if (this.uploading) return false
      if (this.store.loading) return false
      if (this.edit_id) return true
      return this.limit
    },
    can_upload(){
      if (this.store.loading) return false
      if (this.inline_text) return true
      return this.limit
    },
  },
  methods: {
    async onAddInlineText() {  
      const text = this.inline_text
      const id = this.edit_id
      this.onDiscard()

      if (id) await this.store.delete(id)
      const result = await this.store.addSamplePost(text)
      this.$emit('uploaded', result)
    },
    onEdit(id, text){
      this.edit_id = id
      this.prev_text = text
      this.inline_text = text
    },
    onDiscard(){
      this.edit_id = undefined
      this.prev_text = ''
      this.inline_text = ''
    },
    async onRemove(file_id) {
      this.onDiscard()
      await this.store.delete(file_id)
      this.$emit('removed', file_id)
    },
  }
}
